import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import T from "i18n";
import ReactMarkdown from "react-markdown";
import TextSection from "./atoms/TextSection";

const Wrapper = styled(TextSection)``;

const EndOfPageNotes = ({ className }) => {
  const classes = ["EndOfPageNotes"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")} isSmall>
      <ReactMarkdown allowDangerousHtml linkTarget="_blank">
        {T({          
            path: "common.endOfpageNotes"
        })}
      </ReactMarkdown>
    </Wrapper>
  );
};

EndOfPageNotes.displayName = "EndOfPageNotes";

EndOfPageNotes.propTypes = {
  className: PropTypes.string,
};

EndOfPageNotes.defaultProps = {
  className: null,
};

export default EndOfPageNotes;
